/**
 * Context for chat submit action. The provider supplies submitPrompt so
 * children can send a prompt as the user's next message (e.g. HeraldChat).
 */
import { createContext } from "react";

export interface ChatPromptSubmitContextValue {
  /** Submit the given text as the user's next message. No-op if not provided (e.g. Storybook). */
  submitPrompt?: (text: string) => void;
}

export const ChatPromptSubmitContext =
  createContext<ChatPromptSubmitContextValue | null>(null);
